var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MOON",
    transform: "translate(-728.264 -599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    transform: "translate(728.264 599)",
    fill: "none",
    stroke: "#51aabc",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 53,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 51.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "moon-2",
    "data-name": "moon",
    transform: "translate(732.429 604.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3291",
    "data-name": "Trac\\xE9 3291",
    d: "M108.8,93.8l2.329-1.273a.4.4,0,0,0,.158-.158l1.274-2.329a.4.4,0,0,1,.7,0l1.274,2.329a.4.4,0,0,0,.158.158l2.329,1.273a.4.4,0,0,1,0,.7l-2.329,1.274a.4.4,0,0,0-.158.158l-1.274,2.329a.4.4,0,0,1-.7,0l-1.274-2.329a.4.4,0,0,0-.158-.158L108.8,94.492A.4.4,0,0,1,108.8,93.8ZM93.041,70a37.156,37.156,0,1,0,41.68,55.6A59.883,59.883,0,0,1,93.041,70Z",
    transform: "translate(-55.891 -59.108)",
    fill: "#fff4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3292",
    "data-name": "Trac\\xE9 3292",
    d: "M80.827,139.044A4.958,4.958,0,1,1,85.784,144,4.958,4.958,0,0,1,80.827,139.044Zm19.83,8.924A3.966,3.966,0,1,0,96.691,144,3.966,3.966,0,0,0,100.657,147.967ZM84.793,122.188a3.966,3.966,0,1,0-3.966-3.966A3.966,3.966,0,0,0,84.793,122.188Zm57.3-11.9-2.329-1.274a.4.4,0,0,1-.158-.158l-1.274-2.329a.4.4,0,0,0-.7,0l-1.274,2.329a.4.4,0,0,1-.158.158l-2.329,1.274a.4.4,0,0,0,0,.7l2.329,1.273a.4.4,0,0,1,.158.158l1.274,2.329a.4.4,0,0,0,.7,0l1.274-2.329a.4.4,0,0,1,.158-.158l2.329-1.273A.4.4,0,0,0,142.094,110.29Zm-17.641,49.575a5.949,5.949,0,1,0-8.253,5.486,37.155,37.155,0,0,1-36.47-59.937,37.151,37.151,0,1,0,52.307,52.279,37.183,37.183,0,0,1-8.435,5.239A5.918,5.918,0,0,0,124.453,159.866Z",
    transform: "translate(-55.891 -87.5)",
    fill: "#ffe473"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d07686a5.svg";
export { ForwardRef as ReactComponent };